/* eslint-disable no-console */
import {
  bookingProfileVar,
  globalDataVar,
  searchParamsVar,
  searchResultsVar,
  selectedDepartureVar,
} from '../../operations/localState/reactiveVariables';
import {
  buildCommonProductObject,
  getMarketingAirlineCodesFromFlight,
  getSplitExManageRes,
} from './common';
import { getSessionStorageItem } from '../../operations/sessionStorage/utils';
import { SESSION_STORAGE_CHANGE_FLIGHTS, SESSION_STORAGE_AVAILABLE_TRANSFERS } from '../constants';

const siteSection = 'airbooking';

const getChangeFlightrackData = () => {
  const isChangeFlight = getSessionStorageItem(SESSION_STORAGE_CHANGE_FLIGHTS);
  let changeFlightData;
  if (isChangeFlight) {
    changeFlightData = {
      evenType: 'interaction',
      interaction: 'changeFlight',
    };
  }
  return changeFlightData;
};

const getChangeFlightrackDataConfirmation = () => {
  const isChangeFlight = getSessionStorageItem(SESSION_STORAGE_CHANGE_FLIGHTS);
  const isTransferAvailable = getSessionStorageItem(SESSION_STORAGE_AVAILABLE_TRANSFERS);
  let changeFlightData;
  if (isChangeFlight) {
    changeFlightData = {
      evenType: 'interaction',
      interaction: isTransferAvailable ? 'changeFlightWithTransfer' : 'changeFlight',
    };
  }
  return changeFlightData;
};
const defineTrackingToSend = (trackingParamsToSend, globalData, bookingProfile) => {
  const { currentBooking } = bookingProfileVar();
  return {
    ...trackingParamsToSend,
    country: globalData && globalData.country ? globalData.country.toLowerCase() : '',
    language: globalData && globalData.language ? globalData.language.toLowerCase() : '',
    siteSection,
    sailDate: currentBooking?.sailing?.sailDate,
    ship: currentBooking?.sailing?.itinerary?.ship?.code,
    itineraryCode: bookingProfile?.currentBooking?.sailing?.itinerary?.code,
    bookingID: currentBooking?.id,
    departurePort: bookingProfile.currentBooking.sailing.itinerary.departurePort.code,
    currency: bookingProfile.flightProfile.currency,
  };
};
export const trackView = (trackingParams) => {
  if (window.utag) {
    const bookingProfile = bookingProfileVar();
    const globalData = globalDataVar();
    let trackingParamsToSend = { ...trackingParams };
    const splitExValue = getSplitExManageRes();

    // Only add splitExManageRes if it has a value
    if (splitExValue) {
      trackingParamsToSend.splitExManageRes = splitExValue;
    }
    trackingParamsToSend.siteSection = trackingParamsToSend.siteSection || siteSection;

    if (bookingProfile?.flightProfile && bookingProfile?.currentBooking) {
      trackingParamsToSend = defineTrackingToSend(trackingParamsToSend, globalData, bookingProfile);
    }

    window.utag.view(trackingParamsToSend);
  } else {
    // This is necessary because utag.js script is loaded asynchronously
    setTimeout(() => trackView(trackingParams), 1000);
  }
};

export const trackSearchView = () => {
  trackView({ pageName: `${siteSection}:search`, pageType: 'findaflight' });
};

export const trackDepartureResultsView = (arrivalAirportCode) => {
  const changeFlightData = getChangeFlightrackData();
  const searchParams = searchParamsVar();
  const searchResults = searchResultsVar();
  trackView({
    pageName: `${siteSection}:departure`,
    pageType: 'departureFlight',
    ...changeFlightData,
    fsDepartureResults:
      searchResults && searchResults.matchingFlights ? searchResults.matchingFlights.length : 0,
    // searchParams can exist WITHOUT guests (e.g. re-entering Book Flights after a
    // cancellation, where the post-booking cleanup left a partial object) — guard both levels
    // like fsDepartureResults above does.
    fsGuests: searchParams && searchParams.guests ? searchParams.guests.length : 0,
    // TODO: Once we start supporting different types, we should obtain this dynamically
    fsType: 'roundtrip',
    fsDepartureAirportCode: searchParams && searchParams.departureAirportCode,
    fsDestinationAirportCode: arrivalAirportCode,
  });
};

export const trackReturnResultsView = () => {
  const selectedDeparture = selectedDepartureVar();
  const searchResults = searchResultsVar();
  const changeFlightData = getChangeFlightrackData();
  const departureFlight = selectedDeparture && selectedDeparture.flight;
  trackView({
    pageName: `${siteSection}:return`,
    pageType: 'returnFlight',
    ...changeFlightData,
    fsReturnResults:
      searchResults && searchResults.matchingFlights ? searchResults.matchingFlights.length : 0,
    flightDepartureDate: (departureFlight && departureFlight.departDate) || '',
    departureAirlineCode: getMarketingAirlineCodesFromFlight(departureFlight),
  });
};

export const trackGuestInfoView = () => {
  const changeFlightData = getChangeFlightrackData();
  trackView({
    pageName: `${siteSection}:selected`,
    pageType: 'selectedFlight',
    ...changeFlightData,
    ...buildCommonProductObject(),
  });
};

const payLaterLabel = 'paylater';
const payNowLabel = 'paynow';

export const getTrackPaymentData = (onlyPaymentOption) => {
  const changeFlightData = getChangeFlightrackData();
  const globalData = globalDataVar();
  const { currentBooking } = bookingProfileVar();
  const splitExValue = getSplitExManageRes();

  const paymentData = {
    pageName: `${siteSection}:payment`,
    pageType: 'flightPayment',
    ...changeFlightData,
    ...buildCommonProductObject(),
    flightPaymentOption: onlyPaymentOption ? payNowLabel : `${payLaterLabel}-${payNowLabel}`,
    siteSection,
    language: globalData?.language?.toLowerCase() || '',
    ship: currentBooking?.sailing?.itinerary?.ship?.code,
    sailDate: currentBooking?.sailing?.sailDate,
    flightProdCategory: ['Flight'],
    itineraryCode: currentBooking?.sailing?.itinerary?.code,
  };

  // Only add splitExManageRes if it has a value
  if (splitExValue) {
    paymentData.splitExManageRes = splitExValue;
  }

  return paymentData;
};
export const trackPaymentView = (onlyPaymentOption) => {
  trackView(getTrackPaymentData(onlyPaymentOption));
};

export const trackConfirmationView = (payNowSelected, reservationNumber) => {
  const changeFlightData = getChangeFlightrackDataConfirmation();
  trackView({
    pageName: `${siteSection}:confirmation`,
    pageType: 'flightConfirmation',
    ...buildCommonProductObject(true),
    ...changeFlightData,
    flightReservationNumber: reservationNumber,
    flightPaymentSelected: payNowSelected ? payNowLabel : payLaterLabel,
  });
};
